


export const formatCurrency = (value, locale, decimals = 0) => {
    // Create an instance of Intl.NumberFormat for the current locale and currency
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: decimals, // Do not show any digits after the decimal point
        maximumFractionDigits: decimals, // Do not show any digits after the decimal point
    });

    // Format the value
    let ret = formatter.format(value);
    ret = ret.replace("CA", "");
    ret = ret.replace("USD", "");

    // replace all 8239 with 32 (non-breaking space)
    ret = ret.replace(/\u202f/g, ' ');

    // replace all 160 with 32 (non-breaking space)
    ret = ret.replaceAll(/\u00A0/g, ' ');

    // remove all non-ASCII characters
    ret = ret.replace(/[^\x00-\x7F]/g, "");

    return ret;
}

export const formatPercentage = (value, locale) => {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'percent',
        minimumFractionDigits: 2 // Adjust as needed
    });

    const formattedPercentage = formatter.format(value);
    return formattedPercentage;
}

export const formatUnits = (units, locale) => {
    const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 3, // Do not show any digits after the decimal point
        maximumFractionDigits: 3, // Do not show any digits after the decimal point
    });

    return formatter.format(units);
}